import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import EmptyState from '../shared/components/EmptyState';
import Skeleton from '../shared/components/Skeleton';
import StatusPill from '../shared/components/StatusPill';
import { date, invoiceTotal, money } from '../shared/formatters';
import PortalHeader from './PortalHeader';

// Shared list screen for estimates and quotes (E3) — both reuse the
// invoices collection with a doc_type discriminator.
export default function BillingDocs({ docType }) {
  const { data } = useData();
  const { client, base } = usePortalClient();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 200);
    return () => clearTimeout(timer);
  }, []);

  const docs = useMemo(
    () => data.invoices.filter((item) => item.client_id === client.id && (item.docType || 'invoice') === docType),
    [client.id, data.invoices, docType]
  );

  const copy = docType === 'quote'
    ? { eyebrow: 'Documents & payments', title: 'Your quotations', description: 'View quotations and download copies for your records.', empty: 'No quotations yet', emptyMsg: 'Quotations for proposed work will appear here.' }
    : { eyebrow: 'Documents & payments', title: 'Your estimates', description: 'View estimates and download copies for your records.', empty: 'No estimates yet', emptyMsg: 'Estimates for proposed work will appear here.' };

  if (loading) {
    return <Skeleton rows={4} />;
  }

  return (
    <>
      <PortalHeader eyebrow={copy.eyebrow} title={copy.title} description={copy.description} />

      {!docs.length ? (
        <EmptyState title={copy.empty} message={copy.emptyMsg} />
      ) : (
        <section className="portal-card no-padding invoice-list">
          {docs.map((doc) => (
            <Link to={`${base}/${docType === 'quote' ? 'quotes' : 'estimates'}/${doc.id}`} key={doc.id}>
              <div>
                <strong>{doc.number}</strong>
                <span>{doc.title}</span>
              </div>
              <span>Issued {date(doc.issued_at)}</span>
              <strong>{money(invoiceTotal(doc))}</strong>
              <StatusPill invoice={doc} />
            </Link>
          ))}
        </section>
      )}
    </>
  );
}
